import { Link } from "react-router-dom";
import {
  ExternalLink, Globe, Building2, GraduationCap, Heart, Briefcase,
  Home as HomeIcon, ShieldCheck, Radio, MapPin,
} from "lucide-react";
import useSEO from "../hooks/useSEO";

const RESOURCES = [
  {
    category: "Immigration & citoyenneté",
    icon: Globe,
    items: [
      { name: "Immigration, Réfugiés et Citoyenneté Canada (IRCC)", url: "https://www.canada.ca/fr/immigration-refugies-citoyennete.html", desc: "Portail officiel de l'immigration canadienne." },
      { name: "S'établir au Canada", url: "https://www.canada.ca/fr/immigration-refugies-citoyennete/services/setablir-canada.html", desc: "Guide officiel pour vos premiers pas au Canada." },
      { name: "Programme pilote — communautés francophones (PPICF)", url: "https://www.canada.ca/fr/immigration-refugies-citoyennete/services/immigrer-canada/pilotes-rurale-franco/immigration-franco.html", desc: "Programme d'immigration pour communautés francophones rurales." },
      { name: "Programme d'appui à l'immigration francophone (PAIF)", url: "https://www.canada.ca/fr/immigration-refugies-citoyennete/organisation/partenaires-fournisseurs-services/ciif/paif/apercu.html", desc: "Financement de projets communautaires." },
      { name: "FCFA — Fédération des communautés francophones et acadiennes", url: "https://fcfa.ca/", desc: "Réseau national francophone hors Québec." },
      { name: "Patrimoine canadien — Devenez bénévole", url: "https://www.canada.ca/fr/patrimoine-canadien/campagnes/devenez-benevole.html", desc: "Bénévolat : premier levier d'ancrage dans la société d'accueil." },
    ],
  },
  {
    category: "Emploi & entrepreneuriat",
    icon: Briefcase,
    items: [
      { name: "BDC — Prêt nouveaux arrivants entrepreneurs", url: "https://www.bdc.ca/", desc: "Financement adapté aux nouveaux arrivants." },
      { name: "Futurpreneur Canada", url: "https://www.futurpreneur.ca/fr/", desc: "Financement et mentorat pour les 18-39 ans." },
      { name: "Volet Entrepreneurs — Québec", url: "https://www.quebec.ca/immigration/programmes-immigration/gens-affaires/entrepreneurs", desc: "Programme d'immigration économique du Québec." },
      { name: "Collège La Cité — PEIF", url: "https://www.collegelacite.ca/", desc: "Parcours entrepreneurial pour immigrants francophones." },
      { name: "PROMIS", url: "https://promis.qc.ca/", desc: "Accompagnement aux personnes immigrantes à Montréal." },
      { name: "Fonds d'emprunt Québec", url: "https://fonds-emprunt.qc.ca/", desc: "Microcrédit et accompagnement entrepreneurial." },
      { name: "EVOL", url: "https://evol.ca/", desc: "Soutien aux entreprises inclusives et diversifiées." },
      { name: "CCIQ — Chambre de commerce et d'industrie de Québec", url: "https://cciquebec.ca/", desc: "Réseautage et services aux entreprises de Québec." },
      { name: "RCA Groupe — Services aux entrepreneurs", url: "https://www.rcagroupe.ca/", desc: "Accompagnement d'affaires et Colloque CIEL." },
    ],
  },
  {
    category: "Santé",
    icon: Heart,
    items: [
      { name: "RAMQ — Régie de l'assurance maladie du Québec", url: "https://www.ramq.gouv.qc.ca/", desc: "Inscription à l'assurance maladie du Québec." },
      { name: "OHIP — Assurance-santé de l'Ontario", url: "https://www.ontario.ca/fr/page/assurance-sante-de-lontario", desc: "Assurance santé de l'Ontario." },
      { name: "Assurance-maladie du Nouveau-Brunswick", url: "https://www2.gnb.ca/", desc: "Régime d'assurance santé du Nouveau-Brunswick." },
    ],
  },
  {
    category: "Éducation & formation",
    icon: GraduationCap,
    items: [
      { name: "Université de l'Ontario français", url: "https://www.uontario.ca/", desc: "Microcertificat en gestion de l'immigration francophone." },
      { name: "Université de Saint-Boniface", url: "https://ustboniface.ca/", desc: "Unique université francophone du Manitoba." },
      { name: "Université Laval", url: "https://www.ulaval.ca/", desc: "Université francophone de Québec — recherche et formation." },
    ],
  },
  {
    category: "Organismes d'accueil",
    icon: HomeIcon,
    items: [
      { name: "CANAF — Centre d'Accueil des Nouveaux Arrivants Francophones (Alberta)", url: "https://canaf.ca/", desc: "Aide à l'établissement pour francophones en Alberta." },
      { name: "Le SOIT", url: "https://www.soit.quebec/", desc: "Service d'orientation et d'intégration au travail (Québec)." },
      { name: "Centre R.I.R.E. 2000 — Centre d'aide aux immigrants (Québec)", url: "https://www.r2000.qc.ca/", desc: "Accompagnement des immigrants à Québec." },
      { name: "Option-travail — Centre-conseil en emploi et en diversité culturelle", url: "https://optiontravail.com/", desc: "Employabilité et diversité culturelle." },
    ],
  },
  {
    category: "Institutions & gouvernement",
    icon: Building2,
    items: [
      { name: "Gouvernement du Canada", url: "https://www.canada.ca/fr.html", desc: "Portail officiel du gouvernement fédéral." },
      { name: "Gouvernement du Québec", url: "https://www.quebec.ca/", desc: "Portail officiel du gouvernement du Québec." },
      { name: "Service Canada — NAS en ligne", url: "https://www.canada.ca/fr/emploi-developpement-social/services/numero-assurance-sociale.html", desc: "Demander votre numéro d'assurance sociale." },
      { name: "Statistique Canada", url: "https://www.statcan.gc.ca/fr/debut", desc: "Données officielles sur le marché du travail." },
      { name: "Immigration Manitoba", url: "https://www.immigratemanitoba.com/", desc: "Programme d'immigration du Manitoba." },
    ],
  },
  {
    category: "Provinces & territoires (hors Québec)",
    icon: MapPin,
    items: [
      { name: "Gouvernement du Nouveau-Brunswick — gnb.ca", url: "https://www2.gnb.ca/", desc: "Site officiel du Nouveau-Brunswick." },
      { name: "Gouvernement de l'Alberta — alberta.ca", url: "https://www.alberta.ca/", desc: "Site officiel de l'Alberta." },
      { name: "Province du Manitoba — manitoba.ca", url: "https://www.manitoba.ca/", desc: "Site officiel du Manitoba." },
      { name: "Gouvernement de l'Ontario — ontario.ca", url: "https://www.ontario.ca/", desc: "Site officiel de l'Ontario." },
      { name: "Province de la Colombie-Britannique", url: "https://www2.gov.bc.ca/", desc: "Site officiel de la Colombie-Britannique." },
      { name: "Gouvernement de la Saskatchewan", url: "https://www.saskatchewan.ca/", desc: "Site officiel de la Saskatchewan." },
      { name: "Gouvernement de Terre-Neuve-et-Labrador", url: "https://www.gov.nl.ca/", desc: "Site officiel de Terre-Neuve-et-Labrador." },
      { name: "Gouvernement de la Nouvelle-Écosse", url: "https://novascotia.ca/", desc: "Site officiel de la Nouvelle-Écosse." },
      { name: "Gouvernement de l'Île-du-Prince-Édouard", url: "https://www.princeedwardisland.ca/fr", desc: "Site officiel de l'Île-du-Prince-Édouard." },
      { name: "Gouvernement du Yukon", url: "https://yukon.ca/", desc: "Site officiel du Yukon." },
      { name: "Gouvernement du Nunavut", url: "https://www.gov.nu.ca/", desc: "Site officiel du Nunavut." },
      { name: "Gouvernement des Territoires du Nord-Ouest", url: "https://www.gov.nt.ca/", desc: "Site officiel des Territoires du Nord-Ouest." },
    ],
  },
  {
    category: "Municipalités & régionalisation",
    icon: Building2,
    items: [
      { name: "Ville de Québec", url: "https://www.ville.quebec.qc.ca/", desc: "Site officiel de la Ville de Québec." },
      { name: "Ville de Montréal", url: "https://montreal.ca/", desc: "Site officiel de la Ville de Montréal." },
      { name: "Ville de Toronto", url: "https://www.toronto.ca/", desc: "Site officiel de la Ville de Toronto." },
      { name: "Ville d'Ottawa", url: "https://ottawa.ca/fr", desc: "Site officiel de la Ville d'Ottawa." },
    ],
  },
  {
    category: "Communication & médias",
    icon: Radio,
    items: [
      { name: "Radio-Canada", url: "https://ici.radio-canada.ca/", desc: "Réseau public francophone du Canada." },
    ],
  },
  {
    category: "Protection & droits",
    icon: ShieldCheck,
    items: [
      { name: "Commission des droits de la personne du Québec", url: "https://www.cdpdj.qc.ca/", desc: "Défense des droits fondamentaux au Québec." },
      { name: "Loi 25 — Protection des renseignements personnels", url: "https://www.cai.gouv.qc.ca/", desc: "Commission d'accès à l'information du Québec." },
      { name: "Commission consultative pour le vivre-ensemble (Ville de Québec)", url: "https://participationcitoyenne.ville.quebec.qc.ca/commission-consultative-pour-le-vivre-ensemble", desc: "Instance consultative de la Ville de Québec." },
    ],
  },
];

export default function RessourcesEnLigne() {
  useSEO({
    title: "Ressources en ligne",
    description: "Sources officielles utiles pour votre établissement, votre intégration et votre entrepreneuriat au Canada : IRCC, RAMQ, BDC, provinces, municipalités, organismes d'accueil francophones.",
  });
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid="ressources-page">
      <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Médiathèque</p>
      <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-foreground tracking-tight leading-[1.05]">
        Ressources <span className="text-primary">en ligne</span>
      </h1>
      <p className="text-muted-foreground mt-4 max-w-2xl leading-relaxed">
        Une sélection de sources officielles et de partenaires francophones fiables pour vous accompagner à chaque étape de votre parcours au Canada.
      </p>

      <div className="mt-14 space-y-14">
        {RESOURCES.map((section, i) => {
          const Icon = section.icon;
          return (
            <section key={i} data-testid={`resource-section-${i}`}>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-2xl bg-secondary flex items-center justify-center text-primary">
                  <Icon className="w-6 h-6" />
                </div>
                <h2 className="font-display font-bold text-2xl sm:text-3xl">{section.category}</h2>
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                {section.items.map((r, j) => (
                  <a
                    key={j}
                    href={r.url}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`resource-link-${i}-${j}`}
                    className="card-surface p-5 group hover:border-primary/40 transition-all"
                  >
                    <div className="flex items-start justify-between gap-3">
                      <h3 className="font-display font-semibold text-base leading-snug text-foreground group-hover:text-primary transition">
                        {r.name}
                      </h3>
                      <ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-primary flex-shrink-0 mt-1" />
                    </div>
                    <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{r.desc}</p>
                  </a>
                ))}
              </div>
            </section>
          );
        })}
      </div>

      <div className="mt-16 rounded-3xl bg-secondary/60 border border-primary/10 p-8 text-center">
        <h2 className="font-display font-bold text-2xl">Une ressource à suggérer ?</h2>
        <p className="text-muted-foreground mt-2 max-w-xl mx-auto">
          Écrivez-nous — nous ajoutons régulièrement les sources francophones utiles à notre communauté.
        </p>
        <Link to="/contact" className="btn-primary mt-6 inline-flex" data-testid="ressources-cta-contact">
          Nous écrire
        </Link>
      </div>
    </div>
  );
}
